module.exports = __webpack_public_path__ + "static/media/arrow-right.e7f1f40e.svg";